import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";

export default class extends Controller {

    connect() {
        const popoverElement = this.element.closest('.seat-wrapper').querySelector('.popover-wrapper')
        if (popoverElement) {
            new bootstrap.Popover(this.element, {
                template: popoverElement.innerHTML,
                boundary: '#seating_plan',
                offset: [0, 20],
                placement: 'top',
                content: '.',
                sanitize: false,
                trigger: 'hover'
            })
        }
    }

    disconnect() {
        const instance = bootstrap.Popover.getInstance(this.element)
        if (instance) {
            instance.dispose()
        }
    }
}
